const tableCellUser = {
  photo: 'PHOTO',
  Typography: 'No results found'
};

export default tableCellUser;
